
import Header from "../Header/Header"
import Nav from "../Nav/Nav"

const Layout = ({ children }) => (
    <div>

        <Header />
        <Nav />
        {children}
        
    </div>
)

export default Layout